<template>
  <div class="content">
    <modal-detail-plan :workplan="singlePickPlan"/>
    <div>
      <b-card>
        <h6 class="mb-4 font-weight-bold">Filter</h6>
          <b-row align-v="center">
            <b-col>
                <b-form-group
                  label="Status"
                >
                  <custom-select
                    v-model="filterPlan"
                    :options="planFilter.filters"
                    multiple
                    @change="$refs.table.refresh()"
                    placeholder="Select status"
                  />
                </b-form-group>
            </b-col>
            <b-col>
              <div class="but ton-project mt-2 d-flex justify-content-end">
                <b-button
                  class="reset mr-3"
                  variant="outline-warning"
                  @click="resetFilter"
                >
                  Reset Filter
                </b-button>
                <b-button
                  class="next"
                  variant="warning"
                  @click="applyFilter"
                >
                  Apply Filter
                </b-button>
              </div>
            </b-col>
        </b-row>
      </b-card>
    </div>
    <div class="table-list my-4">
      <div class="py-3">
        <b-button
          class="btn-add"
          variant="warning"
          id="show-btn" @click="openModalCreate()"
        >
          Create New Plan
        </b-button>
        <div>
          <modal-form-work-plan
            :modeUpdate="modeUpdate"
            :text="text"
            @result-request="resultRequest"
            :dataUpdate="singlePickPlan"
          />
        </div>
      </div>
      <div>
        <div>
          <b-row v-show="!items.length">
            <b-col>
              <div align="center">
              <img src="@/assets/icon-no-invoice.png"/>
            </div>
            </b-col>
          </b-row>
          <b-table
            ref="table"
            v-show="items.length"
            :items="fetchListPlan"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            striped
            responsive
          >
            <template #cell(no)="{ index }">
              {{ index + 1 }}
            </template>
            <template #cell(firstDate)="data">
              <div>
                {{ formatFullDate(data.value) }}
              </div>
            </template>
            <template #cell(action)="{ item }">
              <div class="data" >
                <b-link
                  class="text-secondary mx-2"
                  @click="openModalModeUpdate(item)"
                >
                  <fa-icon icon="edit"/>
                </b-link>
                <b-link
                  class="text-secondary mx-2"
                >
                  <fa-icon icon="eye" @click="openModalView(item)"/>
                </b-link>
                <b-link
                  class="text-secondary mx-2"
                >
                  <fa-icon v-b-modal.modal-center icon="trash" @click="openModalConfirmDelete(item)"/>
                </b-link>
              </div>
            </template>
          </b-table>
        </div>
        <modal-delete-plan :plan-name="formDelete.title" @remove="deletePlan"/>
        <div class="d-flex justify-content-between">
          <div>
            <span>Show</span>
            <b-form-select
              v-model="perPage"
              :options="pageOptions"
              @change="$refs.table.refresh()"
              class="page-option ml-2 mr-2 w-auto"
              size="sm"
            />
            <span>Entries</span>
          </div>
          <div>
            <b-pagination
              class="mb-0"
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="totalRows"
              pills
              hide-goto-end-buttons
              @input="$refs.table.refresh()"
            />
            <span class="show-entries mr-auto">
              {{`Show ${totalRows === 0 ? 0 : ((currentPage-1) * perPage) + 1} to ${totalRows > ((currentPage) * perPage) ? ((currentPage) * perPage) : totalRows} of ${totalRows} entries`}}
            </span >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modalFormWorkPlan from './ModalFormWorkPlan.vue'
import modalDetailPlan from './ModalViewWorkPlan.vue'
import modalDeletePlan from './ModalDeletePlan.vue'
import api from '@/api'

export default {
  components: {
    modalFormWorkPlan,
    modalDetailPlan,
    modalDeletePlan
  },
  data() {
    return {
      items: [],
      lastNotificationDate: null,
      listPlanWork: [],
      singlePickPlan: {
        title: '',
        target: '',
        budget: '',
        firstDate: '',
        endDate: '',
        dayLength: '',
        workPlanStatusId: '',
        descStatus: ''
      },
      formDelete: {},
      fields: [
        { key: 'no', label: 'No' },
        { key: 'title', label: 'Rencana Kerja' },
        { key: 'target', label: 'Target', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'firstDate', label: 'Tanggal Mulai', tdClass: 'text-center', thClass: 'text-center' },
        { key: 'action', label: 'Action', tdClass: 'text-center', thClass: 'text-center' }
      ],
      filterPlan: ['Active'],
      planFilter: {
        show: true,
        filters: ['Active', 'Inactive']
      },
      text: '',
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      totalPage: 0,
      pageOptions: [10, 20, 50, 100],
      messageAlert: '',
      candidateId: '',
      targetDeleteById: '',
      isBusy: false,
      modeUpdate: false
    }
  },
  methods: {
    openModalCreate() {
      this.text = 'Create New Work Plan'
      this.modeUpdate = false
      this.singlePickPlan = {
        title: '',
        target: '',
        budget: '',
        firstDate: '',
        endDate: '',
        dayLength: '',
        workPlanStatusId: '',
        descStatus: ''
      }
      this.$bvModal.show('modal-form-work-plan')
    },
    openModalView(item) {
      this.singlePickPlan = item
      this.$bvModal.show('modal-view-plan-work')
    },
    openModalModeUpdate(item) {
      this.text = 'Update Work Plan'
      this.modeUpdate = true
      this.singlePickPlan = item
      this.$bvModal.show('modal-form-work-plan')
    },
    openModalConfirmDelete(item) {
      this.$bvModal.show('modal-delete-plan')
      this.formDelete = { ...item }
    },
    async getSinglePlan(id) {
      try {
        const { data } = await api.workPlan.getIdPlan(id)
        this.singlePickPlan = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async fetchListPlan() {
      const paramStatus = this.filterPlan[0]
      try {
        const { data } = await api.workPlan.getListPlan()
        this.listPlanWork = this.mapStatusByDate(data.data)
      } catch (error) {
        console.log(error)
      }
      const now = new Date()
      this.listPlanWork.forEach(item => {
        if (item.endDate && new Date(item.endDate) > now) {
          this.showNotification(item)
        }
      })
      this.items = this.listPlanWork.filter(item => item.status === paramStatus)
      this.items.map((v, i) => {
        if (i % 2 === 0) {
          v._rowVariant = 'warning'
        }
      })
      this.totalRows = this.items.length
      this.totalPage = Math.ceil(this.totalRows / this.perPage)
      return this.items
    },
    async deletePlan() {
      this.isBusy = true
      try {
        await api.workPlan.deletePlan(this.formDelete.id)
        this.$nextTick(() => {
          this.$bvToast.toast(`Success delete plan ${this.formDelete.title}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
          this.$refs.table.refresh()
        })
      } catch (error) {
        console.log(error)
        this.$nextTick(() => {
          this.$bvToast.toast(error.message ? error.message.messageEng : error.data.messageEng, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      this.isBusy = false
    },
    applyFilter() {
      this.$refs.table.refresh()
    },
    resetFilter() {
      this.filterPlan = this.$options.data().filterPlan
      this.$refs.table.refresh()
    },
    mapStatusByDate(data) {
      const now = new Date()
      data.map((item, i) => {
        if (item.endDate < now.toLocaleDateString('en-CA') ||
        item.workPlanStatusId === 'c08cb8d2-768e-5432-45d5-6daa74423004' ||
        item.workPlanStatusId === 'c08cb8d2-768e-5432-45d5-6daa74423003') {
          item.status = 'Inactive'
        } else {
          item.status = 'Active'
        }
      })
      return data
    },
    showNotification(item) {
      const now = new Date()
      const startDate = new Date(item.firstDate)
      const endDate = new Date(item.endDate)
      if (now < startDate &&
        item.workPlanStatusId !== 'Cancel' &&
        item.workPlanStatusId !== 'Done') {
        const remainingDays = this.calculateRemainingDays(startDate)
        const message = `Work plan "${item.title}" is on going. It will start in ${remainingDays} days.`
        this.$bvToast.toast(message, {
          title: 'Reminder',
          variant: 'warning',
          solid: true,
          autoHideDelay: 2000
        })
      } else if (now >= startDate && now <= endDate &&
        item.workPlanStatusId !== 'Cancel' &&
        item.workPlanStatusId !== 'Done') {
        const remainingDays = this.calculateRemainingDays(endDate)
        const message = `Work plan "${item.title}" is running. It will end in ${remainingDays} days.`
        this.$bvToast.toast(message, {
          title: 'Reminder',
          variant: 'warning',
          solid: true,
          autoHideDelay: 2000
        })
      } else if (now >= endDate && (!this.lastNotificationDate || now - this.lastNotificationDate > 86400000)) {
        this.lastNotificationDate = now
        const message = `Work plan "${item.title}" has ended.`
        this.$bvToast.toast(message, {
          title: 'Reminder',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000
        })
      }
    },
    calculateRemainingDays(endDate) {
      const now = new Date()
      const end = new Date(endDate)
      const timeDiff = end.getTime() - now.getTime()
      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24))
      return daysDiff
    },
    resultRequest(data) {
      this.$nextTick(() => {
        this.$bvToast.toast(data.text, {
          headerClass: 'd-none',
          solid: true,
          variant: data.variantAlert
        })
        this.$refs.table.refresh()
      })
    },
    getDayName(dayIndex) {
      const days = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
      return days[dayIndex]
    },
    getMonthName(monthIndex) {
      const months = [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
      ]
      return months[monthIndex]
    },
    formatFullDate(dateTimeString) {
      if (dateTimeString) {
        const dateObj = new Date(dateTimeString)
        const day = this.getDayName(dateObj.getDay())
        const date = dateObj.getDate()
        const month = this.getMonthName(dateObj.getMonth())
        const year = dateObj.getFullYear()
        const formattedTime = dateObj.toLocaleTimeString('id-ID', {
          hour: '2-digit',
          minute: '2-digit'
        })

        return `${day}, ${date} ${month} ${year} ${formattedTime}`
      } else {
        return 'Invalid Date'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.btn-add{
  color: white;
}

.table-list{
  background-color: white;
  border-radius: 6px;
  padding: 15px;
}

#modal-center p{
  font-size: 22px;
}

.fixed-top-right {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 9999;
  width: 500px;
}
</style>
